import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {SignatureRoutingModule} from './signature-routing.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import {DigitalSignatureDialogInfoComponent} from './digital-signature-dialog-info/digital-signature-dialog-info.component';
// tslint:disable-next-line:max-line-length
import {DigitalSignatureRectangleCreateComponent} from './digital-signature-rectangle-create/digital-signature-rectangle-create.component';
// tslint:disable-next-line:max-line-length
import {DigitalSignatureRectangleDialogComponent} from './digital-signature-rectangle-dialog/digital-signature-rectangle-dialog.component';
import {DigitalSignatureRectangleInitComponent} from './digital-signature-rectangle-init/digital-signature-rectangle-init.component';
import {DigitalSignatureRectangleSignedDocumentComponent} from './digital-signature-rectangle-signed-document/digital-signature-rectangle-signed-document.component';

@NgModule({
  declarations: [
    DigitalSignatureDialogInfoComponent,
    DigitalSignatureRectangleCreateComponent,
    DigitalSignatureRectangleDialogComponent,
    DigitalSignatureRectangleInitComponent,
    DigitalSignatureRectangleSignedDocumentComponent
  ],
  imports: [
    CommonModule,
    SignatureRoutingModule,
    FormsModule,
    HttpClientModule,
    PdfViewerModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatOptionModule,
    MatSelectModule,
    MatToolbarModule,
    MatCardModule,
    MatTooltipModule,
    MatDialogModule,
    MatIconModule,
  ],
  exports: [
    DigitalSignatureDialogInfoComponent,
    DigitalSignatureRectangleCreateComponent,
    DigitalSignatureRectangleDialogComponent,
    DigitalSignatureRectangleInitComponent,
    DigitalSignatureRectangleSignedDocumentComponent]
})
export class SignatureModule {
}
